import React, { useState, useEffect } from 'react';
import { UseAxios } from '../Server-Api-Instance';
import {createTheme, ThemeProvider} from '@mui/material';
import { TextField, Button, Card, CardContent, Typography, Box, CircularProgress, Grid } from '@mui/material';
import { green, red } from '@mui/material/colors';
import theme  from '../Shared/theme.js';
import '../Shared/CommonStyle.css';

const VarianceCard = ({ username }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [varianceData, setVarianceData] = useState(null);
    const [error, setError] = useState(null);

    const calculateDefaultDateRange = () => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const last30Days = new Date(yesterday);
        last30Days.setDate(yesterday.getDate() - 30);

        const formatDate = (date) => date.toISOString().split('T')[0];
        setStartDate(formatDate(last30Days));
        setEndDate(formatDate(yesterday));
    };

    const fetchVarianceData = async (start, end) => {
        setLoading(true);
        setError(null);
        try {
            const axios = UseAxios(false);
            const response = await axios.get('/variance', {
                params: { username, startDate: start, endDate: end }
            });
            setVarianceData(response.data);
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response ? err.response.data.error : 'An unexpected error occurred.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        calculateDefaultDateRange(); // Set default date range on component mount
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            fetchVarianceData(startDate, endDate); // Fetch data for default date range
        }
    }, [startDate, endDate, username]);

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    const handleSubmit = () => {
        fetchVarianceData(startDate, endDate); // Fetch data for selected date range
    };

    const formatCurrency = (value) => {
        const formatted = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2,
        }).format(value);
        return formatted.replace('£', '£ ');
      };


    const renderVariance = (label, current, previous, variance) => (
        <Card variant="outlined" sx={{
            mb: 1,
            // borderRadius: 3,
            // boxShadow: '0 3px 5px 2px rgba(105, 135, 255, .3)',
            p: 1,
            backgroundColor: '#bdbdc0',
            fontWeight:'bold',
            transition: 'transform 0.3s',
            '&:hover': {
                transform: 'scale(1.05)',
            },
            display: 'flex',
            color:'white',
           
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
        }}>
            <CardContent>
                <Typography variant="h6" sx={{ fontWeight:'bold' }} component="div">{label}</Typography>
                <Typography sx={{ mt: 1.5, color:'white' }} color="text.secondary">
                    <b>Current:</b> {formatCurrency(current)}
                </Typography>
                <Typography sx={{ mt: 1.5, color:'white' }} color="text.secondary">
                   <b> Previous:</b> {formatCurrency(previous)}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ background: variance >= 0 ? green[500] : red[500], color:'white',padding:'10px', fontWeight: 'bold', mt: 1.5 }}
                >
                    Variance: {variance.toFixed(2)}%
                </Typography>
            </CardContent>
        </Card>
    );

    return (
        <ThemeProvider theme={theme}>
        <Box className="dashboard">
        <Box className="heading-box">
             VARIANCE DETAILS
            </Box>
 
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} lg={6} sm={6} md={5}>
                    <TextField
                    sx={{
                        '.MuiSvgIcon-root':
                        {
                          color: '#be9f55',
                        },
                      }}
                        label="Departure Start Date"
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={5}>
                    <TextField
                        label="Departure End Date"
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />
                </Grid>
                {/* <Grid item xs={12} sm={4} md={4}>
                    
                    <Button type="submit" className="fetch-button" variant="contained"  onClick={handleSubmit}
                        disabled={!startDate || !endDate}
                        fullWidth>
                    Get Variance
          </Button>
                </Grid> */}
            </Grid>

            {loading && <div className="loading-message" sx={{ mt: 4, textAlign: 'center' }}>Loading data...</div>}

{error && <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>Error: {error}</Typography>}
            
{varianceData && (
                    varianceData.current_year_SellAmount || varianceData.previous_year_SellAmount || varianceData.sellAmountVariance || varianceData.current_year_AgencyCommission || varianceData.previous_year_AgencyCommission || varianceData.agencyCommissionVariance ? (
                <Box sx={{ mt: 2 }}>
                    {renderVariance(
                        "Sell Amount Variance",
                        varianceData.current_year_SellAmount || 0,
                        varianceData.previous_year_SellAmount || 0,
                        varianceData.sellAmountVariance || 0
                    )}
                    {renderVariance(
                        "Agency Commission Variance",
                        varianceData.current_year_AgencyCommission || 0,
                        varianceData.previous_year_AgencyCommission || 0,
                        varianceData.agencyCommissionVariance || 0
                    )}
                </Box>
                    ) : (
                        <div className="no-data-message" sx={{ mt: 2, textAlign: 'center' }}>No data available for the selected date range.</div>
                    )
                )}
            </Box>
        </ThemeProvider>
    );
};

export default VarianceCard;
